import React, { useEffect, useState } from 'react';

const GoalsProgressCard = () => {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimate(true);
    }, 100); // Reduced from 500ms to 100ms
    return () => clearTimeout(timer);
  }, []);

  const progressBars = [
    { progress: 146, color: 'from-[#22A06B] to-[#4BCE97]' },
    { progress: 357, color: 'from-[#F49611] to-[#F6A839]' },
    { progress: 0, color: 'from-[#8A8A8A] to-[#B0B0B0]' }
  ];

  const goalCards = [
    { percentage: 270, icon: '☂️', label: 'Retirement', color: 'from-[#113262] to-[#1C52A0]' },
    { percentage: 0, icon: '🏠', label: 'Home', color: 'from-[#F49611] to-[#F6A839]' },
    { percentage: 0, icon: '💰', label: 'Emergency', color: 'from-[#113262] to-[#436FB0]' }
  ];

  return (
    <div className="bg-white rounded-xl shadow-md p-4 sm:p-6 h-full flex flex-col">
      {/* Header Section */}
      <div className={`mb-4 sm:mb-6 transition-all duration-400 ${
        animate ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4'
      }`}>
        <h3 className="text-lg sm:text-xl font-semibold text-[#113262] mb-2">
          Goals Progress Dashboard
        </h3>
        <p className="text-sm text-[#545454]">
          Track your financial goals and monitor progress toward achievement.
        </p>
      </div>

      {/* Stats Row */}
      <div className="flex justify-between mb-4 sm:mb-6">
        <div className={`text-center transition-all duration-400 delay-50 ${
          animate ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4'
        }`}>
          <div className="text-2xl sm:text-3xl font-bold text-[#113262] mb-1">4</div>
          <div className="text-xs text-[#545454]">Goals Setup</div>
        </div>
        
        <div className={`text-center transition-all duration-400 delay-100 ${
          animate ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4'
        }`}>
          <div className="text-2xl sm:text-3xl font-bold text-[#113262] mb-1">0</div>
          <div className="text-xs text-[#545454]">Goals Fulfilled</div>
        </div>
        
        <div className={`text-center transition-all duration-400 delay-150 ${
          animate ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4'
        }`}>
          <div className="text-2xl sm:text-3xl font-bold text-[#113262] mb-1">3</div>
          <div className="text-xs text-[#545454]">Funds</div>
        </div>
      </div>

      {/* Progress Bars Row */}
      <div className="flex justify-center space-x-4 sm:space-x-6 mb-4 sm:mb-6">
        {progressBars.map((bar, index) => (
          <div key={index} className="flex flex-col items-center">
            <div className={`text-lg sm:text-xl font-bold mb-2 text-[#113262] transition-all duration-400 ${
              animate ? 'opacity-100 scale-100' : 'opacity-0 scale-75'
            }`}
            style={{ transitionDelay: `${200 + index * 50}ms` }}>
              {bar.progress}%
            </div>
            
            <div className="space-y-1">
              {[...Array(4)].map((_, barIndex) => (
                <div key={barIndex} className="w-6 h-1.5 bg-[#E6E6E6] rounded-full overflow-hidden">
                  <div 
                    className={`h-full bg-gradient-to-r ${bar.color} rounded-full transition-all duration-800 ease-in-out`}
                    style={{ 
                      transitionDelay: `${350 + index * 50 + barIndex * 25}ms`,
                      width: animate ? (bar.progress > 0 ? '100%' : '0%') : '0%'
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* Goal Cards Grid */}
      <div className="grid grid-cols-3 gap-2 sm:gap-3 mb-4 sm:mb-6 flex-1">
        {goalCards.map((goal, index) => (
          <div
            key={index}
            className={`bg-gradient-to-br ${goal.color} p-2 sm:p-3 rounded-lg text-center border-2 border-transparent hover:border-[#1C52A0] transition-all duration-400 transform hover:-translate-y-1 ${
              animate ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
            }`}
            style={{ transitionDelay: `${500 + index * 50}ms` }}
          >
            <div className={`w-6 h-6 sm:w-8 sm:h-8 bg-white/20 rounded-lg flex items-center justify-center text-sm sm:text-lg mx-auto mb-1 sm:mb-2 transition-all duration-400 ${
              animate ? 'scale-100 rotate-0' : 'scale-0 -rotate-180'
            }`}
            style={{ transitionDelay: `${550 + index * 50}ms` }}>
              {goal.icon}
            </div>
            
            <div className="text-lg sm:text-xl font-bold text-white mb-1">
              {goal.percentage}%
            </div>
            
            <h4 className="text-xs font-semibold text-white">
              {goal.label}
            </h4>
          </div>
        ))}
      </div>

      {/* Action Button */}
      <div className={`transition-all duration-400 ${
        animate ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
      }`}
      style={{ transitionDelay: '700ms' }}>
        <button 
          onClick={() => window.location.href = "https://club.maxiomwealth.com/goals/finplan/create"}
          className="w-full bg-gradient-to-r from-[#113262] to-[#1C52A0] text-white px-4 sm:px-6 py-2 rounded-lg text-xs sm:text-sm font-semibold hover:scale-105 hover:shadow-lg transition-all duration-300"
        >
          Review Goals Progress
        </button>
      </div>
    </div>
  );
};

export default GoalsProgressCard;